import type { LucideIcon, LucideProps } from "lucide-react";

/**
 * DS icon wrapper. Lucide-style line icons at the brand stroke weight (1.6),
 * round caps/joins (lucide default). Sizes 13/14/16/18 per the design system.
 */
export interface IconProps extends Omit<LucideProps, "ref"> {
  icon: LucideIcon;
  size?: number;
}

export function Icon({ icon: I, size = 16, strokeWidth = 1.6, ...rest }: IconProps) {
  return <I size={size} strokeWidth={strokeWidth} {...rest} />;
}
